import React from 'react';
import dayjs from 'dayjs';
import * as iUTC from 'dayjs/plugin/utc';
import * as iTimezone from 'dayjs/plugin/timezone';

import useConfig from '../../../Hooks/useConfig';
import useAppService from '../../../Hooks/useAppService';

dayjs.extend(iUTC.default);
dayjs.extend(iTimezone.default);

export interface Props {
  customDateFormat?: boolean;
  date: string; // TODO use a dayjs object not string - or add inputFormat
  format?: string;
  utc?: boolean;
  stripTz?: boolean;
  tz?: string;
  stripTime?: boolean;
}

const DateDisplay = (props: Props): JSX.Element => {
  const { date, format, utc, stripTz, tz, stripTime, customDateFormat } = props;
  const config = useConfig();
  const appService = useAppService();

  // stripTz expect into to be "2002-02-14T14:23:56+06:00" --> 2002-02-14T14:23:56
  let dateString = stripTz ? date.substr(0, 19) : date;
  dateString = stripTime ? date.substr(0, 10) : dateString;
  const timezone = tz;

  function getDefaultFormat(): string {
    const defaultFormat = config.displayFormatDate[appService.lang.replace('-', '_')];
    return defaultFormat ? defaultFormat : config.displayFormatDate[config.defaultLanguage];
  }
  function getDate(): dayjs.Dayjs {
    const dateVal = utc ? dayjs.utc(dateString) : dayjs(dateString);

    if (timezone) {
      return dateVal.tz(timezone);
    }

    return dateVal;
  }

  const dateFormat = format || getDefaultFormat();

  return !customDateFormat ? (
    <>{getDate().format(dateFormat)}</>
  ) : (
    <>{dayjs(date).format('DD.MM.YY')}</>
  );
};
export default DateDisplay;
